import { Spinner } from '@repo/ui'
import { createRouter } from '@tanstack/react-router'

import { queryClient } from './lib/query-client'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPendingComponent: RoutePendingSkeleton,
})

function RoutePendingSkeleton() {
  return (
    <div className="flex min-h-96 items-center justify-center">
      <Spinner className="text-muted-foreground size-6" />
    </div>
  )
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
